module.exports = __webpack_public_path__ + "img/hmore.561ded7a.png";